import { render, staticRenderFns } from "./listProduct.vue?vue&type=template&id=36f24312&"
import script from "./listProduct.vue?vue&type=script&lang=js&"
export * from "./listProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports